import _slicedToArray from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/esnext.global-this.js";
import "core-js/modules/esnext.promise.all-settled.js";
var T, b;
import { useRef as c, useState as S } from "react";
import { disposables as m } from '../utils/disposables.js';
import { useDisposables as g } from './use-disposables.js';
import { useFlags as y } from './use-flags.js';
import { useIsoMorphicEffect as A } from './use-iso-morphic-effect.js';
typeof process != "undefined" && typeof globalThis != "undefined" && typeof Element != "undefined" && ((T = process == null ? void 0 : process.env) == null ? void 0 : T["NODE_ENV"]) === "test" && typeof ((b = Element == null ? void 0 : Element.prototype) == null ? void 0 : b.getAnimations) == "undefined" && (Element.prototype.getAnimations = function () {
  return console.warn(["Headless UI has polyfilled `Element.prototype.getAnimations` for your tests.", "Please install a proper polyfill e.g. `jsdom-testing-mocks`, to silence these warnings.", "", "Example usage:", "```js", "import { mockAnimationsApi } from 'jsdom-testing-mocks'", "mockAnimationsApi()", "```"].join("\n")), [];
});
var L = function (r) {
  return r[r.None = 0] = "None", r[r.Closed = 1] = "Closed", r[r.Enter = 2] = "Enter", r[r.Leave = 4] = "Leave", r;
}(L || {});
function R(t) {
  var n = {};
  for (var e in t) t[e] === !0 && (n["data-".concat(e)] = "");
  return n;
}
function x(t, n, e, i) {
  var _S = S(e),
    _S2 = _slicedToArray(_S, 2),
    r = _S2[0],
    o = _S2[1],
    _y = y(t && r ? 3 : 0),
    s = _y.hasFlag,
    a = _y.addFlag,
    l = _y.removeFlag,
    u = c(!1),
    f = c(!1),
    E = g();
  return A(function () {
    var d;
    if (t) {
      if (e && o(!0), !n) {
        e && a(3);
        return;
      }
      return (d = i == null ? void 0 : i.start) == null || d.call(i, e), C(n, {
        inFlight: u,
        prepare: function prepare() {
          f.current ? f.current = !1 : f.current = u.current, u.current = !0, !f.current && (e ? (a(3), l(4)) : (a(4), l(2)));
        },
        run: function run() {
          f.current ? e ? (l(3), a(4)) : (l(4), a(3)) : e ? l(1) : a(1);
        },
        done: function done() {
          var p;
          f.current && typeof n.getAnimations == "function" && n.getAnimations().length > 0 || (u.current = !1, l(7), e || o(!1), (p = i == null ? void 0 : i.end) == null || p.call(i, e));
        }
      });
    }
  }, [t, e, n, E]), t ? [r, {
    closed: s(1),
    enter: s(2),
    leave: s(4),
    transition: s(2) || s(4)
  }] : [e, {
    closed: void 0,
    enter: void 0,
    leave: void 0,
    transition: void 0
  }];
}
function C(t, _ref) {
  var n = _ref.prepare,
    e = _ref.run,
    i = _ref.done,
    r = _ref.inFlight;
  var o = m();
  return j(t, {
    prepare: n,
    inFlight: r
  }), o.nextFrame(function () {
    e(), o.requestAnimationFrame(function () {
      o.add(M(t, i));
    });
  }), o.dispose;
}
function M(t, n) {
  var o, s;
  var e = m();
  if (!t) return e.dispose;
  var i = !1;
  e.add(function () {
    i = !0;
  });
  var r = (s = (o = t.getAnimations) == null ? void 0 : o.call(t).filter(function (a) {
    return a instanceof CSSTransition;
  })) != null ? s : [];
  return r.length === 0 ? (n(), e.dispose) : (Promise.allSettled(r.map(function (a) {
    return a.finished;
  })).then(function () {
    i || n();
  }), e.dispose);
}
function j(t, _ref2) {
  var n = _ref2.inFlight,
    e = _ref2.prepare;
  if (n != null && n.current) {
    e();
    return;
  }
  var i = t.style.transition;
  t.style.transition = "none", e(), t.offsetHeight, t.style.transition = i;
}
export { R as transitionDataAttributes, x as useTransition };